import { z } from 'zod'

export const JobStatusRowSchema = z.object({
    category: z.string().nullish(),
    createdAt: z.string(),
    displayColour: z.string().nullish(),
    displayTextColour: z.string().nullish(),
    id: z.string().uuid(),
    key: z.string(),
    name: z.string(),
    updatedAt: z.string(),
})

export type JobStatusRow = z.infer<typeof JobStatusRowSchema>

export const ListJobStatusesResponseSchema = z.object({
    statuses: z.array(JobStatusRowSchema),
})

export type ListJobStatusesResponse = z.infer<
    typeof ListJobStatusesResponseSchema
>

export const ReconcileJobWorkflowResponseSchema = z.object({
    statusKey: z.string(),
    workflowRevision: z.number().int().nonnegative(),
})

export type ReconcileJobWorkflowResponse = z.infer<
    typeof ReconcileJobWorkflowResponseSchema
>
